<template>
  <div class="col-md-12 col-12">
    <v-row>
      <v-col md="3" v-for="datas in data" :key="datas.key">
        <b-card
          class="h-100 custome-image my-auto"
          overlay
          :img-src="datas.thumbnail"
          img-alt="Card Image"
          text-variant="white"
          :footer="datas.tahun + '-' + datas.tahun_akhir"
          footer-tag="footer"
          footer-bg-variant="primary"
          footer-border-variant="dark"
          style="object-fit: cover"
          @click="downloadItem(datas.file)"
        >
        </b-card>
      </v-col>
    </v-row>
  </div>
</template>
<style scoped>
.card-footer {
  margin-top: auto;
  text-align: center;
}
</style>
// <script>
// import axios from "axios";
export default {
  name: "CardSempro",
  data() {
    return {
      styleObject: {
        backgroundColor: "#3751E4",
        width: "123%",
        height: "100%",
        display: "inherit",
        position: "absolute",
        top: "26%",
        float: "right",
        left: "-10%",
      },
    };
  },
  props: {
    data: Array,
  },
  methods: {
    changeurl(params) {
      this.$router.push({ path: params }).catch(() => {});
    },
    downloadItem(label) {
        const externalRouteUrl = this.$endpoint + 'uploads/buku_wisudawan/' + label;
        window.open(externalRouteUrl, '_blank');
    },
  },
};
</script>
